import { CellActions as CoreCellActions } from "@/components/ui/table/core/CellActions";
import { ColumnType, ReportCell, ReportColumn } from "@/types/evaluate";
import { useUser } from "@/context/user-context";
import { useState, useEffect } from "react";

interface ReportCellActionsProps {
  cell: ReportCell;
  column?: ReportColumn;
  retryReportCell?: () => void;
  retryReportCellIsLoading: boolean;
  copyValue?: string;
  className?: string;
}

export const CellActions = ({
  cell,
  column,
  retryReportCell,
  retryReportCellIsLoading,
  copyValue,
  className = "",
}: ReportCellActionsProps) => {
  const [url, setUrl] = useState("");
  const { activeWorkspaceId: workspaceId } = useUser();

  useEffect(() => {
    if (cell.value && cell.value.value) {
      if (cell.value.value.request_id) {
        setUrl(
          `/workspace/${workspaceId}/request/${cell.value.value.request_id}`,
        );
      } else if (cell.value.value.trace_id) {
        setUrl(`/workspace/${workspaceId}/traces/${cell.value.value.trace_id}`);
      }
    }
  }, [cell.value, workspaceId]);

  return (
    <CoreCellActions
      onRetry={
        column?.column_type !== ColumnType.DATASET && retryReportCell
          ? retryReportCell
          : undefined
      }
      isRetryLoading={retryReportCellIsLoading}
      plLinkUrl={url}
      copyText={copyValue}
      showCopy={!!copyValue}
      className={className}
    />
  );
};
